import { render, staticRenderFns } from "./AnchorPage.vue?vue&type=template&id=f2708206&scoped=true"
import script from "./AnchorPage.vue?vue&type=script&lang=js"
export * from "./AnchorPage.vue?vue&type=script&lang=js"
import style0 from "./AnchorPage.vue?vue&type=style&index=0&id=f2708206&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2708206",
  null
  
)

export default component.exports